import { ApplicationService } from "./application.service";
import { ApiUrls, BindQuery } from "./api-urls";
import { GetAllDto } from "../Shared/dto/get-all-dto";
import { LeadModel } from "../Models/lead.model";

export const LeadService = {
    save: (data: LeadModel) => {
        if (data.id) return ApplicationService.put(ApiUrls.LEADS_PUT(data.id), data)
        return ApplicationService.post<any>(ApiUrls.LEADS_POST, data)
    },
    get: (getAllDto: GetAllDto) => {
        return ApplicationService.get<any>(BindQuery(ApiUrls.LEADS_GET, getAllDto))
    },
    getById: (leadsId: number) => {
        return ApplicationService.get<any>(ApiUrls.LEADS_BY_ID(leadsId))
    }
}